interface ComponentProps {
    label: string,
    inputName: string,
    formDataValue: any,
    placeHolder: string,
    gatherFormData: any,
    formDataParam: string,
}

export default function ContactPageForm({ label, inputName, formDataValue, placeHolder, gatherFormData, formDataParam }: ComponentProps) {
    return (
        <div className="flex flex-col space-y-1 w-full">
            <label className="text-sm font-medium text-gray-700">{label}</label>
            <input
                name={inputName}
                placeholder={placeHolder}
                value={formDataValue}
                className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-pink-500"
                required
                onChange={(e) => gatherFormData(formDataParam, e)}
            />
        </div>
    )
}